import React from 'react';
import { Link } from 'react-router-dom';
import resalatProfile from '../../ass/resalat-profile.png'
import { HiBars3CenterLeft, HiArrowDownTray } from "react-icons/hi2";
import resume from '../../ass/RESALAT_RESUME.pdf'

const Header = () => {
    return (
        <div className="navbar fixed shadow-md  z-50 w-ful top-0 left-0 right-0 lg:px-20 px-7 py-5 bg-[#202327]">
 
            <div className="flex-1">
                <div className="avatar flex items-center gap-3">
                <div className="w-12">
                        <Link to='/'><img className='rounded-full' src={resalatProfile} alt="" /></Link>
                </div>
                <p className='text-gray-300 text-xl'>Resalat Islam</p>
            </div>
            </div>
            <div className="flex-none">
                <ul className="menu menu-horizontal px-1 hidden lg:flex text-gray-300 ">
                    <li className='hover:text-white'><a href='#home'className='active:bg-black'>Home</a></li>
                    <li className='hover:text-white'><a href='#about' className='active:bg-black'>About</a></li>
                    <li className='hover:text-white'><a href='#portfolio' className='active:bg-black'>Portfolio</a></li>
                    {/* <li className='hover:text-white'><Link to='/blog' className='active:bg-black' target='_blank'>Blog</Link></li> */}
                    <li className='hover:text-white'><a href='#contact' className='active:bg-black'>Contact</a></li>
                    <a href={resume} download className="btn bg-[#1C1F23] border-0 shadow-2xl hover:bg-black text-red-500">DownLoad CV<HiArrowDownTray className='text-xl ml-2'/></a>
                </ul>
            </div>
            <div className='lg:hidden'>
                <label htmlFor="my-drawer" className="btn bg-[#1C1F23] border-0 shadow-2xl hover:bg-black drawer-button "><HiBars3CenterLeft /></label>
            </div>
        </div>
    );
};

export default Header;